import { VBHover } from './hover'
import { pluginFactory } from '../../utils/plugins'

const VBHoverPlugin = /*#__PURE__*/ pluginFactory({
  directives: { VBHover }
})

export { VBHoverPlugin, VBHover }
